import type { Session } from 'next-auth';

/**
 * ログイン判定の唯一の基準（GF-2374）。
 *
 * サーバ（getServerSession）とクライアント（useSession().data）で必ずこの関数を通すことで、
 * 両者の判定がズレて「カートの保存先(localStorage)」と「カート画面の表示元(サーバカート)」が
 * 食い違う事故を防ぐ。user.id が無ければ会員としての操作は何もできないため、id の有無を基準にする。
 */
export const isLoggedIn = (session: Session | null | undefined): boolean => !!session?.user?.id;
